import request from 'sb-request'
import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { array, constants, links } from 'common/helpers'

import { womanQuizData, menQuizData, subscriptionQuizData } from './quizData'


/**
 * Now the steps data are stored locally
 * This implementation was made to be easy to replace, getting data from the server
 */
const fetchSteps = ({ isMale, isSubscriptionSteps = false }) => {
  reducers.view.quizPage.setFetching(true)

  let data = isMale ? menQuizData : womanQuizData

  if (isSubscriptionSteps) {
    data = subscriptionQuizData.map((quizData) => ({ ...quizData, tags: array.shuffle(quizData.tags) }))
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data)
    }, 100)
  })
    .then((data) => {
      reducers.view.quizPage.setSteps(data)

      return data
    })
}

const updateStep = (value) => {
  reducers.view.quizPage.updateStepIndex(value)
}

const setTag = (id) => {
  reducers.view.quizPage.setTagValueById(id)
}

const fetchProducts = (gender) => {
  reducers.view.quizPage.setFetching(true)

  return request.get(`rest/quiz/products/${gender}`, {
    modifyResult: (items) => (
      items.map((item) => {
        item.img = item.image
        delete item.image
        return item
      })
    ),
  })
    .then(
      (products) => reducers.view.quizPage.setProducts(products),
      () => {
        reducers.view.quizPage.setFetching(false)
        return Promise.reject()
      }
    )
}

const setSelectedProducts = (selectedProducts) =>
  reducers.view.quizPage.setSelectedProducts(array.unique(selectedProducts))

/**
 * { quiz, products}
 * @param body
 * @returns {*}
 */
const saveQuiz = (body) => {
  const { models: { me: { isLoggedIn } } } = getState()

  if (isLoggedIn) {
    reducers.view.quizPage.setWaiting(true)

    return request.post('rest/quiz/answer', {
      body,
    })
      .then(
        (response) => {
          actions.misc.cookies.removeItem(constants.cookieNames.unregisteredUserQuizData)
          reducers.view.quizPage.setWaiting(false)

          return response
        },
        () => {
          reducers.view.quizPage.setWaiting(false)
          return Promise.reject()
        }
      )
  }

  actions.misc.cookies.setItem(constants.cookieNames.unregisteredUserQuizData, body)

  return Promise.resolve()
}

/**
 *
 * @param {Object} answers
 * @param {Object} options
 * @param {Boolean} options.withErrorModal
 * @returns {*}
 */
const saveRecommendationsQuiz = (answers, { withErrorModal = true } = {}) => {
  const { models: { me: { isLoggedIn, gender } } } = getState()

  const quizLink       = gender === 'male' ? links.quizMen : links.quiz
  const isAnswersValid = [ 'brands', 'scentType', 'style', 'occasion', 'season' ]
    .every((name) => answers[name])


  if (!isAnswersValid) {
    actions.models.router.push(quizLink)

    return Promise.reject()
  }

  if (isLoggedIn) {
    reducers.view.quizPage.setWaiting(true)

    return request.post('rest/recommendations-quiz/answer', {
      body: answers,
      withErrorModal,
    })
      .then(
        (response) => {
          actions.misc.cookies.removeItem(constants.cookieNames.unregisteredUserQuizData)
          actions.models.me.updateFinishedQuizNew('recommendations', true)

          return response
        },
        () => {
          actions.misc.cookies.setItem(constants.cookieNames.unregisteredUserQuizData, answers)
        }
      )
      .finally(() => {
        reducers.view.quizPage.setWaiting(false)
      })
  }

  actions.misc.cookies.setItem(constants.cookieNames.unregisteredUserQuizData, answers)

  return Promise.resolve()
}

const saveSubscriptionQuiz = (body) => {
  reducers.view.quizPage.setWaiting(true)

  return request.post('rest/subscription-quiz/answer', {
    body,
  })
    .finally(() => reducers.view.quizPage.setWaiting(false))
}

const updateAnswers = (data) => reducers.view.quizPage.updateAnswers(data)

const updateAnswer = (name, data) => reducers.view.quizPage.updateAnswer({ name, data })

const setAnswer = (name, data) => reducers.view.quizPage.setAnswer({ name, data })

const resetQuizData = () => reducers.view.quizPage.resetQuizData()


export default {
  fetchSteps,
  updateStep,
  fetchProducts,
  setTag,
  setSelectedProducts,
  updateAnswers,
  updateAnswer,
  setAnswer,
  saveQuiz,
  saveSubscriptionQuiz,
  saveRecommendationsQuiz,
  resetQuizData,
}
